const LangReportLostCard = {
	"reportLost.copy._message": [
		"Please confirm your mailing list to receive replacement card.",
		"Vui lòng cập nhật địa chỉ để nhận thẻ thay thế.",
	],
	"reportLost.message._updateAddress": [
		"Your address has been updated.",
		"Địa chỉ đã được cập nhật.",
	],
}

export default LangReportLostCard



// WEBPACK FOOTER //
// ./src/resources/pages/LangReportLostCard.js